import { DeadlineType } from '@/modules/common/enums/deadline-type.ts';
import type { Deadline } from '@/modules/common/types/ui.ts';

const MIN_DAYS_BEFORE_DEADLINE = 1;

export function getBeforeDeadlineDate(deadline: Deadline) {
  return deadline.type !== DeadlineType.None && deadline.date.diffNow('day').days > MIN_DAYS_BEFORE_DEADLINE
    ? deadline.date
    : undefined;
}

export function getDeadlineDate(deadline: Deadline) {
  return deadline.type === DeadlineType.None ? null : deadline.date.toSQLDate();
}

export function getDeadlineRequest(deadline: Deadline) {
  switch (deadline.type) {
    case DeadlineType.WorkingDays:
      return {
        days: deadline.days,
      };
    case DeadlineType.Days:
      return {
        end_date: deadline.date.toSQLDate(),
      };
    case DeadlineType.Date:
      return {
        end_date: deadline.date.toSQLDate(),
      };
    default:
      throw new Error(`An unexpected deadline type ${deadline.type} (${DeadlineType[deadline.type]}) was received.`);
  }
}
